"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var numberWithDecimals = function numberWithDecimals(number, decimals) {
  return parseFloat(Math.round(number * 100) / 100).toFixed(decimals);
};
var convertCentsToDollars = function convertCentsToDollars(number) {
  return number / 100;
};
var _default = function _default(number) {
  var showDecimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var includeCents = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var money;
  if (includeCents) {
    money = convertCentsToDollars(number);
  } else {
    money = number || 0;
  }
  if (number) {
    if (showDecimals) {
      money = numberWithDecimals(money, 2);
    }
    money = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  if (Number.isNaN(money)) {
    return '';
  }
  return "$".concat(money);
};
exports.default = _default;